var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "transfer_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.91 14.182v15.272h15.272v10.182L60 21.818 42.182 4v10.182zm-5.092 20.363h15.273v15.273H21.818V60L4 42.182l17.818-17.818z",
    clipRule: "evenodd"
  })));
};
export { SvgTransfer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI2LjkwOTEgMTQuMTgxOFYyOS40NTQ1SDQyLjE4MThWMzkuNjM2NEw2MCAyMS44MTgyTDQyLjE4MTggNFYxNC4xODE4SDI2LjkwOTFaTTIxLjgxODIgMzQuNTQ1NUgzNy4wOTA5VjQ5LjgxODJIMjEuODE4MlY2MEw0IDQyLjE4MThMMjEuODE4MiAyNC4zNjM2VjM0LjU0NTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";